import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import TopBar from '../../../components/TopBar';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import SBDetailsPageActionButtons from '../components/SBDraftDetailsPageActions';
import SBDebitNoteForm from '../../selfBilledDebitNotes/components/SBDebitNoteForm';
import { useGetDebitNoteHandler } from '../../debitNotes/dataHandlers/getCreditNoteHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';

export default function SBDraftDebitNoteDetailsPage() {
  useDocumentTitle('Self Billed Debit Note Details');
  const { document_id } = useParams();
  const navigate = useNavigate();

  const { debitNote, isLoading } = useGetDebitNoteHandler(document_id);
  if (isLoading || !debitNote) {
    return <DocumentSkeletonForm />;
  }

  const handleBack = () => {
    navigate('/self-billed-drafts?tab=debitNotes');
  };

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <Box sx={{ pb: 4 }}>
        <TopBar title="Debit Note Details" subTitle={debitNote?.document_id}>
          <SBDetailsPageActionButtons onBack={handleBack} />
        </TopBar>
      </Box>
      <SBDebitNoteForm onSubmit={() => {}} onCancel={() => {}} initialData={debitNote} readOnly={true} />
    </Stack>
  );
}
